export default "/images/iqvia-oce.svg?9621f1fff7d29dbffe59300213ed43d8";